import script from "./RadioGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioGroup.vue?vue&type=script&lang=ts&setup=true"

import "./RadioGroup.vue?vue&type=style&index=0&id=e1e363c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1e363c8"]])

export default __exports__